import {
  Component,
  inject,
  input,
  model,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { Table, TableModule } from 'primeng/table';
import { PATH_PATIENTS, PATH_PATIENT_DASHBOARD } from 'src/app/patients/patients.global';
import { AuthStore } from 'src/app/calvin-emr-shared/state/auth/auth.store';
import { Patient } from '../../calvin-emr-shared/models/patient.model';
import { User } from '../../calvin-emr-shared/models/user.model';
import { PrimeTemplate } from 'primeng/api';
import { InputTextModule } from 'primeng/inputtext';

import { ButtonDirective } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { IconField } from 'primeng/iconfield';
import { InputIcon } from 'primeng/inputicon';

@Component({
  selector: 'app-patient-table',
  templateUrl: './patient-table.component.html',
  styleUrls: ['./patient-table.component.scss'],
  standalone: true,
  imports: [
    TableModule,
    PrimeTemplate,
    InputTextModule,
    ButtonDirective,
    TooltipModule,
    IconField,
    InputIcon
],
})
export class PatientTableComponent implements OnInit, OnDestroy {
  currentUser: User = new User();

  /**
   * The PrimeNG table HTML element.
   */
  @ViewChild('patientTable') patientTable: Table | undefined;

  /**
   * The fields to filter the table by when using the search bar.
   */
  tableFilterFields: string[] = ['mrn', 'id', 'firstName', 'lastName'];

  loading = input(false);

  /**
   * Array of all patients held by the current user.
   */
  patients = input<Patient[]>([]);

  // vtn2 NOTE: model() provides two-way binding via selectedPatients/selectedPatientsChange.
  selectedPatients = model<Patient[]>([]);

  private router = inject(Router);
  private authStore = inject(AuthStore);

  constructor() {
    const user = this.authStore.user();
    if (user) {
      this.currentUser = user;
    }
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }
  /**
   * Filters the data in the table based on the text in the search field
   * HTML input element. The data is filtered based on whether the any
   * of the fields in the tableFilterFields array contain the text.
   *
   * @param target The search field HTML input element.
   */
  filterTable(target: EventTarget | null) {
    if (target) {
      this.patientTable?.filterGlobal((target as HTMLInputElement).value, 'contains');
    }
  }

  /**
   * Route to the patient page with the clicked row's patient id.
   *
   * @param {string} id The ID of the patient to route to.
   */
  navigateToPatient(id: string) {
    this.router.navigate([PATH_PATIENTS, PATH_PATIENT_DASHBOARD, this.currentUser.role, id]);
  }

  get isAdmin() {
    return this.currentUser.isAdmin;
  }
}
